/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

//------------------------------------------------INDICES-------------------------------------------------
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';

// SPI (Standardised Precipitation Index)
Blockly.Blocks['analyse_spi'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("SPI - Standardised Precipitation Index");
    
      this.setInputsInline(false);
      this.setPreviousStatement(true, 'spi');
      this.setNextStatement(true, getAllowedOutputs('spi'));
      this.setInputsInline(false);
      this.setStyle('indices');
      this.setTooltip(Blockly.Msg.SPI_BLOCK_TOOLTIP);
      this.setHelpUrl("");
    }
};